<section>
  <!---------------------------->
  <!-- ToolBar:-->
  <!---------------------------->
  <mat-toolbar class="toolbar">
    <mat-toolbar-row>
      <ng-container [ngTemplateOutlet]="logoAndSettingsIcon" [ngTemplateOutletContext]="{ url: '/broker/dashboard' }" ></ng-container>
      <button *ngIf="externalUrl"
              class="flex justify-between items-baseline" mat-raised-button color="primary"
              (click)="onClickBackTohHome()">
        <mat-icon class="icon font-small">open_in_new</mat-icon>
        <span class="m-l-15">Back to Home</span>
      </button>
      <ng-container *ngTemplateOutlet="supportIconTpl; context: {$implicit: '/broker/support'}"></ng-container>
      <ng-container [ngTemplateOutlet]="accountAndLogoutIconTpl"></ng-container>
    </mat-toolbar-row>
  </mat-toolbar>
  
  <!---------------------------->
  <!-- Menu Buttons:-->
  <!---------------------------->
  <div class="border-bottom m-l-25 m-r-25">
    <button [routerLink]="'/broker/reporting'" mat-button>Dashboard</button>
    <button [routerLink]="'/broker/applications'" mat-button>Applications</button>
    <button [routerLink]="'/broker/persons'" mat-button>Members</button>
  </div>
</section>